// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"02ed672e","628":"6f71c239"}[chunkId] + ".chunk.css";
};